import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import './ForcePasswordChange.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const ForcePasswordChange = () => {
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (formData.newPassword.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/force-change-password`, {
        newPassword: formData.newPassword
      }, {
        withCredentials: true
      });

      if (response.data.requiresMFA) {
        navigate('/verify-mfa');
      } else if (response.data.user) {
        await checkAuth();
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="force-password-change-container">
      <div className="force-password-change-card">
        <div className="force-password-change-header">
          <h1>🔐 Change Your Password</h1>
          <p>For security reasons, you must change your password before continuing.</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} className="force-password-change-form">
          <div className="form-group">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-input"
              value={formData.newPassword}
              onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
              required
              minLength={8}
              placeholder="Enter new password (min. 8 characters)"
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Confirm New Password</label>
            <input
              type="password"
              className="form-input"
              value={formData.confirmPassword}
              onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
              required
              minLength={8}
              placeholder="Confirm new password"
            />
          </div>
          <div className="password-requirements">
            <p className="requirements-title">Password Requirements:</p>
            <ul>
              <li>At least 8 characters long</li>
              <li>Use a combination of letters, numbers, and symbols for better security</li>
            </ul>
          </div>
          <button
            type="submit"
            className="btn btn-primary btn-large"
            disabled={loading}
          >
            {loading ? 'Changing Password...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
